// ##############################
// // // LoginPage view styles
// #############################

import {
  container,
  cardTitle
} from "assets/jss/material-dashboard-pro-react.jsx";

const singlePageStyle = theme => ({
  container: {
    ...container,
    zIndex: "4",
    // marginTop: "100px",
    [theme.breakpoints.down("sm")]: {
      // paddingBottom: "100px"
    },
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    height: "100vh",
  },
  cardTitle: {
    ...cardTitle,
    color: "#FFFFFF"
  },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  socialLine: {
    padding: "0.9375rem 0"
  },
  forgotPassword: {
    display: "inline-block",
    padding: "20px 0",
    color: "#5d737e",
    cursor: "pointer",
    fontWeight: "normal",
    "&:hover": {
      color: "#2b2d42",
    }
  }
});

export default singlePageStyle;
